export { default } from './ComponentProxy';
